import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Button,
  Table,
  Modal,
  // Form,
} from 'antd';
import {
  // EditFilled,
  DeleteFilled,
  // PlusOutlined,
  // UploadOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import * as Config from '../../../appConfig';

const { confirm } = Modal;

const DocumentsInfo = ({
  employee: { id: employeeId, documents } = [],
  onDocumentDelete,
  onDocumentDownload,
  onDocumentView,
  uploadDocument,
  ability,
}) => {
  console.log('documents/////', documents);
  // const [form] = Form.useForm();
  // const [addNewModalVisible, setAddNewModalVisible] = useState(false);
  // const [editModalVisible, setEditModalVisible] = useState(false);
  // const [editItem, setEditItem] = useState(null);

  const confirmDelete = (document) => {
    confirm({
      title: 'Are you sure you want to delete document?',
      icon: <ExclamationCircleOutlined />,
      content:
        document.media && document.media[0] && document.media[0].file_name,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDocumentDelete(document);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  // const showEditModal = (document) => {
  //   setEditItem(document);
  //   setEditModalVisible(true);
  //   setTimeout(() => {
  //     form.resetFields();
  //   }, 300);
  //   //TODO: fix timeout workaround
  // };

  const columns = [
    {
      title: 'File',
      dataIndex: 'media',
      key: 'file',
      render: (value, record) => {
        return record.media && record.media.length
          ? `${record.media[0].file_name}`
          : '';
      },
    },
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type',
    // },
    {
      title: 'Created By',
      dataIndex: ['created_by', 'name'],
      key: 'created_by',
      className: 'width-200',
      ellipsis: true,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      className: 'width-175',
      render: (value, record) => {
        return value ? moment(value).format(Config.DATE_TIME_FORMAT) : '';
      },
    },
    {
      title: 'Action',
      dataIndex: 'file',
      key: 'action',
      className: 'width-200 text-center',
      render: (text, record) => (
        <>
          <Button
            type="link"
            size="middle"
            onClick={() => onDocumentView(record)}
            title="View Document"
          >
            <EyeOutlined style={{ fontSize: '18px' }} />
          </Button>
          <Button
            type="link"
            size="middle"
            onClick={() => onDocumentDownload(record)}
            title="Download Document"
          >
            <DownloadOutlined style={{ fontSize: '18px' }} />
          </Button>
          {ability.toDeleteDocument && (
            <Button
              type="link"
              size="middle"
              onClick={() => confirmDelete(record)}
              title="Delete Document"
            >
              <DeleteFilled style={{ fontSize: '18px' }} />
            </Button>
          )}
        </>
      ),
    },
  ];

  // const props = {
  //   name: 'file',
  //   action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  //   multiple: false,
  //   onChange(info) {
  //     if (info.file.status !== 'uploading') {
  //       console.log(info.file, info.fileList);
  //     }
  //     if (info.file.status === 'done') {
  //       console.success(`${info.file.name} file uploaded successfully`);
  //     } else if (info.file.status === 'error') {
  //       console.error(`${info.file.name} file upload failed.`);
  //     }
  //   },
  // };

  // const handleUpload = ({ onSuccess, onError, file }) => {
  //   onFileUpload({ onSuccess, onError, file });
  // };

  return (
    <>
      <Row>
        <Col xs={0} md={19}>
          {/* <Button
            type="link"
            size="middle"
            onClick={() => {
              onAddOrUpdateDocumentClick({
                entityId: employeeId,
                entityType: 'employee',
              });
            }}
          >
            <PlusOutlined />
            Add New Document
          </Button>
           */}
        </Col>
        <Col xs={24} md={5} style={{ textAlign: 'right' }}>
          {ability.toCreateDocument && uploadDocument}
          {!ability.toCreateDocument && <p>&nbsp;</p>}
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} md={24}>
          <Table
            dataSource={documents}
            columns={columns}
            pagination={false}
            size="small"
            rowKey="id"
          />
        </Col>
      </Row>
      {/* <Modal
        title="Add new document"
        visible={addNewModalVisible}
        onOk={() => setAddNewModalVisible(false)}
        confirmLoading={false}
        onCancel={() => setAddNewModalVisible(false)}
        destroyOnClose={true}
      >
        <Form
          layout="vertical"
          className="ant-form-custom"
          form={form}
          onFinish={(values) => console.log(values)}
        >
          <Form.Item label="Document Type" name="docType">
            <Select placeholder="Please select">
              {[
                { key: 'Aadhar', value: 'Aadhar' },
                { key: 'DL', value: 'Driving Licence' },
                { key: 'PAN', value: 'PAN Card' },
                { key: 'Other', value: 'Others' },
              ].map((doc) => (
                <Select.Option key={doc.key} value={doc.key}>
                  {doc.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Document Number" name="docNumber">
            <Input placeholder="Document Number" />
          </Form.Item>
          <Upload name="file" customRequest={onFileUpload} maxCount="1">
            <Button icon={<UploadOutlined />}>Click to upload</Button>
          </Upload>
          <Space>
            <Button type="secondary" size="middle" onClick={null}>
              Cancel
            </Button>
            <Button type="primary" size="middle" htmlType="submit">
              Add Employee
            </Button>
          </Space>
        </Form>
      </Modal> */}
      {/* <Modal
        title="Edit document"
        visible={editModalVisible}
        onOk={() => {
          form.submit();
          setEditModalVisible(false);
        }}
        confirmLoading={false}
        onCancel={() => {
          form.resetFields();
          setEditModalVisible(false);
        }}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          className="ant-form-custom"
          form={form}
          initialValues={{
            docType: editItem && editItem.type,
            docNumber: editItem && editItem.docNumber,
            docId: editItem && editItem.id,
          }}
          onFinish={(values) => onDocumentUpdate(values)}
        >
          <Form.Item label="Document Type" name="docType">
            <Select placeholder="Please select">
              {[
                { key: 'Aadhar', value: 'Aadhar' },
                { key: 'DL', value: 'Driving Licence' },
                { key: 'PAN', value: 'PAN Card' },
                { key: 'Other', value: 'Others' },
              ].map((doc) => (
                <Select.Option key={doc.key} value={doc.key}>
                  {doc.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Document Number" name="docNumber">
            <Input placeholder="Document Number" />
          </Form.Item>
          <Form.Item hidden={true} name="docId">
            <Input />
          </Form.Item>
        </Form>
      </Modal> */}
    </>
  );
};

DocumentsInfo.defaultProps = {};

DocumentsInfo.propTypes = {
  employee: PropTypes.object.isRequired,
  onDocumentDelete: PropTypes.func.isRequired,
  onDocumentDownload: PropTypes.func.isRequired,
  uploadDocument: PropTypes.instanceOf(React),
  ability: PropTypes.object.isRequired,
};

export default DocumentsInfo;
